import * as React from "react";
import { preventJqueryEsc } from "../../common/utils/preventJqueryEsc";
import { MESSAGE_EDITOR_CONTAINER } from "../const/constants";

export const usePreventDetailsClosingOnEsc = (isOpened: React.MutableRefObject<boolean> = { current: true }) => {
    const containerRef = React.useRef<HTMLDivElement>();

    React.useEffect(() => {
        const onKeyDown = (e: JQuery.Event) => {
            if (isOpened.current) {
                preventJqueryEsc(e);
            }
        };

        const $el = $(containerRef.current).closest(`.${MESSAGE_EDITOR_CONTAINER}`);
        $el.on("keydown", onKeyDown);

        return () => {
            $el.off("keydown", onKeyDown);
        };
    }, []);

    return containerRef;
};
